export function getFlagCode(language) {
    const code = typeof language === 'string' ? language : language === null || language === void 0 ? void 0 : language.code;
    if (code === 'en') {
        return 'gb';
    }
    if (code === 'et') {
        return 'ee';
    }
    return code;
}
